import React from 'react';
import Axios from 'axios';
import moment from 'moment';

// Constants for this dataTable
const cstTableHeaders = [
	'', 	'ID',	'Équipe', 'Saison',	'Domicile',	'Inscription', 	'Joueurs', 	'TMR', 	''];

const cstDefaultSortOrder = [
	'', 	'asc',	'asc', 	  'asc', 	'asc',		'asc', 			'desc',		'desc', ''];

const cstDefaultSortFieldIdx = 2;

// Generic example of dataTable, sort and etc
class TeamsAdmin extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
      dataTable: []
    };
	
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.handleDeleteTeam = this.handleDeleteTeam.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
		this.handleEditTeam = this.handleEditTeam.bind(this);
	}
		
  componentDidMount() {
    this.loadDataFromApi();
  }

	loadDataFromApi() {
    var _this = this;
    Axios.get('/api/teams/extended').then(function (response) {
      _this.createDataTable(response.data);
    });
  }

	createDataTable(dataResults) {
		var _this = this;
		var dataTable = [];

		// Parse results
		dataResults.forEach(function(result, resultIdx) {

			var dataTableRow = [];
			var regDate = new Date(parseInt(result._id.toString().slice(0, 8), 16)*1000);
 
			// dataTableRow.push(0);		// rank
			dataTableRow.push(result._id);
			dataTableRow.push(result.name);
			dataTableRow.push(result.seasonName);
			dataTableRow.push(result.homeSite);
			dataTableRow.push(moment(regDate).utc().format("YYYY-MM-DD"));
			dataTableRow.push(result.playersId.length);
			dataTableRow.push(result.tmrCount);

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		// First data sort
		var sortFieldIdx = cstDefaultSortFieldIdx;
		var sortOrder = cstDefaultSortOrder[cstDefaultSortFieldIdx];

		_this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder) {

		// Manage empty data
		if (dataTable.length === 0) {
			dataTable = [['', 'Aucune entrée']];
		} else {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			dataTable.sort(function(a, b) {

				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
					compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
					compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
					compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) return (sortSign * compVal);
				return (a[0] - b[0]);
			});
		}

		this.setState({
			dataTable: dataTable,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder
		});
	}

	render() {
		//console.log('TeamsAdmin: render');
    return (
      <div className="row">
      <div className="col-md-12">

        <h5>Équipes</h5>
        <div className="card">
          <div className="card-header">
            <i className="fa fa-th-large"></i>
            Équipes (toutes les ligues)
          </div>

					<div className="card-body card-block">
					<div className="table-responsive">
          	<table className="table table-striped table-hover table-sm">
						<thead>
							<tr>
							{cstTableHeaders.map(this.createTableHdrRow)}
							</tr>
						</thead>

        		<tbody>
							{this.state.dataTable.map(this.createDataRow)}
          	</tbody>
  	        </table>
          </div>
          </div>
	      </div>
      </div>
      </div>
    );
  }

	createTableHdrRow(hdrItem, hdrIdx) {

		var classNameStr = '';
		var onClickAction = function() {};

		// No sort on Rank (column 0)
		if (cstDefaultSortOrder[hdrIdx] !== '') {
			classNameStr = 'statelo-sorting';
			onClickAction = this.handleSortTable;
		}

		return (
			<th key={"colid." + hdrIdx} 
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}
	
  createDataRow(dataRow, dataRowIdx) {
		return (
			<tr key={'te.' + dataRowIdx}>
				<td><input name={'edit.' + dataRow[0]} type="button" onClick={this.handleEditTeam} value="Éditer"/></td>
				{dataRow.map(this.createDataCell)}
				<td><input name={'del.' + dataRow[0]} type="button" onClick={this.handleDeleteTeam} value="Supprimer"/></td>
      </tr>
    );
  }

	createDataCell(dataCell, dataCellIdx) {
		return (
			<td key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

  handleEditTeam(e) {
    var elemInfo = e.target.name.split(".");
    var teamId = elemInfo[1];
    const path = "/admsafe/teams/" + teamId;
    this.props.history.push(path);
  }

	handleDeleteTeam(e) {
    var _this = this;
    var elemInfo = e.target.name.split(".");
    var teamId = elemInfo[1];

		var dataTable = this.state.dataTable;
		var arrayElem = dataTable.filter(function(elem) {
			return (elem[0] === teamId);
		});
		
		var teamName = arrayElem[0][1];
		var tmr = parseInt(arrayElem[0][6], 10);
		
		// Validation du TMR
		if ((tmr !== 0) && !isNaN(tmr)) {
			alert("L'équipe " + teamName + " ne peut pas être supprimée à partir de cette table étant donné" + 
				" son nombre de parties jouées non-nul.  Ceci occasionnerait des blancs dans les classements.")
		} else {

			// Suppression
			var r = window.confirm("Supprimer l'équipe: " + teamName);
			if (r === true) {

				Axios.delete('/api/teams/' + teamId).then(function(response) {
          //console.log(response);
					_this.loadDataFromApi();
        })
        .catch(function(error) {
          console.log(error);
        });
			}
		}
	}

	handleSortTable(e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		// Special
		sortFieldIdx -= 1;	// first column is not in dataTable (edit button)

		var dataTable = this.state.dataTable;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

}

export default TeamsAdmin;

